import { render, staticRenderFns } from "./HighlightedInfographicsNew.vue?vue&type=template&id=77dd3dc6&scoped=true&"
import script from "./HighlightedInfographicsNew.vue?vue&type=script&lang=js&"
export * from "./HighlightedInfographicsNew.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedInfographicsNew.vue?vue&type=style&index=0&id=77dd3dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd3dc6",
  null
  
)

export default component.exports